module.exports = __webpack_public_path__ + "img/9-1_04.46ed16bc.jpg";